// https://ue-api-dev.zoefintech.com/api/v1/

import { useTranslation } from 'react-i18next';

import { useMutation, useQuery } from '@tanstack/react-query';

import { getKeyByValue } from '../utils/utils';

import { COMPANY_NAME } from './dashboardApi';
import { getApi, postApi } from './utils/utils';

import { LANGUAGES } from 'constants/languages';

export const usePairInventory = () => {
  const { i18n } = useTranslation();
  const currentLanguage = getKeyByValue(LANGUAGES, i18n.language);

  return useQuery({
    queryKey: ['pair-inventory', currentLanguage],
    queryFn: () => {
      return getApi(`/user/pair/inventory/${COMPANY_NAME}`);
    },
    onSuccess: () => {},
  });
};

export const useTradeExchange = () => {
  return useMutation({
    mutationKey: '',
    mutationFn: (data) => {
      return postApi(`/user/trade/exchange`, {
        pairId: data.pairId,
        quantity: data.quantity,
        targetPairId: data.targetPairId,
      });
    },
    onSuccess: (data) => {
      console.log({ data });
    },
  });
};

export const useBuyOrSellOrder = () => {
  return useMutation({
    mutationKey: '',
    mutationFn: (data) => {
      return postApi(`/user/trade/order`, data);
    },
    onSuccess: (data) => {
      console.log({ data });
    },
  });
};
